import { ManagementCompany } from "../Interfaces"

/**
 * Companies a user may export payroll for.
 * Admins (role 45+) may use the full list. Everyone else is limited to
 * their own company even if the list endpoint returns extras.
 */
export function companiesForPayrollExport(options: {
  companies: ManagementCompany[]
  isAdmin: boolean
  ownCompanyId?: number | null
  selectedCompany?: ManagementCompany | null
}): ManagementCompany[] {
  if (options.isAdmin) {
    return options.companies
  }

  const ownId = options.ownCompanyId || options.selectedCompany?.id
  if (ownId) {
    const match = options.companies.find((company) => company.id === ownId)
    if (match) return [match]
    if (options.selectedCompany?.id === ownId) return [options.selectedCompany]
    return []
  }

  return options.selectedCompany ? [options.selectedCompany] : []
}

export function canSelectPayrollCompany(
  isAdmin: boolean,
  companies: ManagementCompany[],
): boolean {
  return isAdmin && companies.length > 1
}

export function defaultPayrollCompanyId(
  companies: ManagementCompany[],
  preferredId?: number,
): number | undefined {
  if (preferredId && companies.some((company) => company.id === preferredId)) {
    return preferredId
  }
  return companies[0]?.id
}
